import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker";
import Select from 'react-select'
import Application from "../../services/application.service";
import Helper from "../../helper";

const Payment = (props) => {
    let input = props.input;

    const methodArr = [
        { value: "C", label: "Cheque Deposit" },
        { value: "I", label: "Electronic/Internet Transfer" },
        { value: "E", label: "Electronic Collection" },
        { value: "R", label: "Regular Debit Order" }
    ];

    const [CommencementDate, setCommencementDate] = useState(input.commencement_date);
    const [paymentMethod, setPaymentMethod] = useState(input.payment_type ? Helper.findByValue(input.payment_type, methodArr) : {});
    const [isAgree, setIsAgree] = useState(input.is_cheque_agree == 'Y' ? true : false);
    const [annualEscalation, setAnnualEscalation] = useState(input.annual_escalation);

    const handleSubmit = (e) => {
        e.preventDefault();
        var dt = { ...input };

        var formData = Helper.convertFormData(dt);
        formData.set('payment_type', paymentMethod ? paymentMethod.value : '');
        formData.set('is_cheque_agree', isAgree == true ? 1 : '');
        formData.set('commencement_date', CommencementDate);
        formData.set('annual_escalation', annualEscalation);
        formData.append('step', 'payment');

        Application.applicationUpdate(formData).then(res => {
            if (res.success === true) {
                props.setFormCount(6);
            }
        }).catch(err => console.log(err));
    }

    return (
        <>
            <div className="form-wrapper">
                <div className='form-head'>
                    <h2>Enter Your Payment Details </h2>
                </div>
                <div className="form-fields">
                    <div className="sub-form">
                        <div className="row">
                            <div className="col-sm-12">
                                <label htmlFor="name">Method of Payment <span className="asterisk">*</span></label>
                                {(paymentMethod && (paymentMethod.value == 'C' || paymentMethod.value == 'I')) && <p className="text-description"><strong>Payment instructions will be communicated to you once you have submitted your application.</strong></p>}
                            </div>
                            <div className="col-lg-6 col-md-12 form-group">
                                <div className="input-wrap d-flex">
                                    <Select options={methodArr} name="payment_method" value={paymentMethod} onChange={v => setPaymentMethod(v)} placeholder={'Select'}></Select>
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                        </div>
                        {(paymentMethod.value === 'C') &&
                            <div className="note-info-wrapper">
                                <p className="note-info-light">All cheques need to be endorsed as “Non Transferable” and deposited directly into the unit trust inflow account by the investor. Banks do not accept cheques that exceed an amount of R500000.00. The investment will only be made when cheques are cleared.</p>
                                <div className="form-check-alter">
                                    <div className="p-0 form-group form-check">
                                        <div className="input-wrap">
                                            <input type="checkbox" className="form-check-input" defaultChecked={isAgree} onChange={e => setIsAgree(e.target.checked)} id="agreeCheck" name="cheque_agree" />
                                            <label className="form-check-label" htmlFor="agreeCheck">I / We agree to pay bank charges and costs incurred for any cash deposits made. <span className="asterisk">*</span></label>
                                            <div className="validationAlert"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(paymentMethod.value === 'I') &&
                            <div className="note-info-wrapper">
                                <p className="note-info-light">Electronic internet transfers may take up to two business days to appear in the bank account. Units may only be purchased upon receipt of documentation and funds into the account. Please attach proof of transfer.</p>
                            </div>
                        }
                        {(paymentMethod.value === 'E') &&
                            <div className="note-info-wrapper ">
                                <p className="note-info-light">Funds are deducted from the investor’s bank account on receipt of this application form and all supporting documentation. Electronic collection by the Manageris restricted to a maximum of R1 000 000.00 per debit. Where a higher amount than this is requested, multiple debits will be processed on the same day.</p>
                                <p className="note-info"><span>Please Note:</span> Funds invested via electronic collection or debit order may not be redeemed until after 40 days from the date on which such funds were invested into units on your behalf.</p>
                            </div>
                        }
                        {(paymentMethod.value === 'R') &&
                            <div className="note-info-wrapper ">
                                <p className="note-info-light">Funds are deducted from the investor’s bank account on the 1stworking dayof each month or as soon as possible thereafter.</p>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <label htmlFor="name">Commencement date <span className="asterisk">*</span></label>
                                        <div className="input-wrap datepicker-wrap d-flex">
                                            <DatePicker name="commencement_date" selected={CommencementDate ? new Date(CommencementDate) : null} className="form-control" onChange={(date) => setCommencementDate(Helper.dateFormat(date, 'yyyy-MM-dd'))} dateFormat="dd/MM/yyyy" peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" autoComplete="off" />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <label htmlFor="name">Annual Escalation (%) <span className="asterisk">*</span></label>
                                        <div className="input-wrap d-flex">
                                            <input type="text" name="annual_escalation" value={annualEscalation} onChange={e => setAnnualEscalation(e.target.value)} className="form-control" />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                </div>
                                <p className="note-info mt-4"><span>Please Note:</span> Funds invested via electronic collection or debit order may not be redeemed until after 40 days from the date on which such funds were invested into units on your behalf.</p>
                            </div>
                        }
                    </div>
                    <div className="warning-msg"><span>*</span> Please note that you must fill the mandatory fields to submit the form.</div>
                </div>
            </div>
            <div className='form-actions'>
                <div className='row'>
                    <div className="col-12 pt-4">
                        <div className="button-wrapper">
                            <button type="button" className="btn btn-ouline" onClick={e => props.setFormCount(4)} >Back</button>
                            <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Payment;